import React from "react";
import { connect } from "react-redux";
import { Progress, Button } from "antd";

import { i18, trb, checkJsonProp, Logout } from "@utilities";
import { AuthActions, KYCActions } from "@redux";
import { STORAGE_ITEMS } from "@config";

class SigningOld extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      modal: false,
      timer: null,
      timerId: null,
      checkScaTimeoutId: null,
      numPages: 0
    };
  }

  componentDidMount = () => {
    const { startSigning } = this.props;

    if (startSigning) {
      this.checkScaInit();
    }
  };

  componentDidUpdate = prevProps => {
    const { sendStartLogin, startLogin } = this.props;

    if (sendStartLogin !== prevProps.sendStartLogin && startLogin) {
      this.checkScaInit();
    }
  };

  checkScaInit = () => {
    const { scaTimeout } = this.props,
      timerId = setInterval(this.timerToken, 1000),
      timer = scaTimeout;

    this.setState({
      timerId,
      timer
    });

    setTimeout(this.checkSca, 1000);
  };

  checkSca = () => {
    const { dispatch, success, resetAll, openChooseCompany, applicationSign } = this.props,
      { timerId, timer } = this.state,
      scaAction = applicationSign ? KYCActions.checkSigningSca : AuthActions.checkSca;

      if (timer < 1) return;

    dispatch(scaAction()).then(response => {
      if (response) {
        const status = checkJsonProp(response, "payload.status");
        switch (status) {
          case "Pending":
            const checkScaTimeoutId = setTimeout(this.checkSca, 5000);
            this.setState({ checkScaTimeoutId });
            break;
          case "Success":
            success();
            this.resetAll(true);
            break;
          case "SelectCompany":
            clearInterval(timerId);
            this.setState({
              timerId: null
            });
            openChooseCompany();
            break;
          case "Failed":
            this.resetAll(true).then(() => {
              resetAll();
            });
            break;
          default:
            console.error("Unknown status");
            this.resetAll();
        }
      } else this.resetAll();
    });
  };

  timerToken = async () => {
      const { timer } = this.state;

    if (timer <= 0) {
      await this.resetAll();
      await this.props.resetAll();
      return;
    }

    this.setState({
      timer: timer - 1
    });
  };

  resetAll = async (notCancel) => {
    const { timerId, checkScaTimeoutId } = this.state;
    const { dispatch } = this.props;

    clearInterval(timerId);
    clearTimeout(checkScaTimeoutId);
    if (!notCancel) {
      await dispatch(KYCActions.cancelSigning());
    }
    localStorage.removeItem(STORAGE_ITEMS.SIGNIN_TOKEN);
    this.setState({
      submitting: false,
      modal: false,
      timer: null,
      timerId: null,
      checkScaTimeout: null
    });
  };

  onDocumentLoadSuccess = numPages => {
    this.setState({
      numPages
    });
  };
  canceledByUser = () => {
    const { changeSubmitting } = this.props;
    this.resetAll();
    Logout();
    sessionStorage.clear();
    changeSubmitting();
  };

  render() {
    const { scaTimeout, controlCode, applicationSign } = this.props,
      { timer } = this.state;

    return applicationSign ? (
      <div className="text-center">
        <div className={applicationSign && "mt-3"}>
          <Progress
            type="circle"
            percent={(100 / scaTimeout) * timer}
            status={timer === 0 ? "exception" : "active"}
            format={() => timer}
            width={100}
            style={{ marginBottom: "24px" }}
          />
          {controlCode && (
            <div className="eb_fs_16 eb_fw_500 mt-3">
              {trb(i18.Labels.ControlCode)}:<br />
              {controlCode}
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className="text-center">
        <div className={applicationSign && "mt-3"}>
          <Progress
            type="circle"
            percent={(100 / scaTimeout) * timer}
            status={timer === 0 ? "exception" : "active"}
            format={() => timer}
            width={100}
            style={{ marginBottom: "24px" }}
          />
          {controlCode && (
            <div className="eb_fs_16 eb_fw_500 mt-3">
              {trb(i18.Labels.ControlCode)}:<br />
              {controlCode}
            </div>
          )}
        </div>
        <Button onClick={this.canceledByUser}>{trb(i18.Buttons.Cancel)}</Button>
      </div>
      // </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { sendAuth, sendStartLogin, startLogin } = state.AuthReducers;
  const { sendSigning, sendSca, startSigning } = state.KYCReducers;

  return {
    sendAuth,
    sendStartLogin,
    startLogin,
    sendSigning,
    sendSca,
    startSigning
  };
}

const connectedSigning = connect(mapStateToProps)(SigningOld);
export { connectedSigning as SigningOld };
